var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { PersonCardMeta } from './person-card-meta';
import { PersonImage } from './person-image';
import { Badge } from '../elements/badge';
var cls = classNames('person-banner');
export var PersonBannerDefaultProps = {
  colorStripSize: 4
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: ", " ", ";\n    font-weight: 300;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    \n    ", "\n  "], ["\n    font-size: ", ";\n    padding: ", " ", ";\n    font-weight: 300;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    \n    ", "\n  "])), theme.FONT_SIZE(14), theme.UNIT(5), theme.UNIT(3), function (_a) {
    var colorStripSize = _a.colorStripSize,
      colorStripColor = _a.colorStripColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "], ["\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "])), theme.COLOR('bright-warm'), colorStripSize, theme.COLOR(colorStripColor));
  }),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16)),
  desktopDevice: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    border-radius: 0 0 ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    border-radius: 0 0 ", " ", ";\n  "])), theme.UNIT(7), theme.UNIT(5), theme.UNIT(6), theme.UNIT(3), theme.UNIT(3))
});
var MetaStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 300;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    font-weight: 300;\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
var NameStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    line-height: 1.1em;\n    font-size: ", "em;\n    font-weight: 400;\n    font-family: ", ";\n    margin: 0;\n  "], ["\n    line-height: 1.1em;\n    font-size: ", "em;\n    font-weight: 400;\n    font-family: ", ";\n    margin: 0;\n  "])), 32 / 16, theme.FONT('heading')),
  desktopDevice: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 40 / 16)
});
var BodyStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InfoStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: ", ";\n  "])), theme.UNIT(4))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Name: styled.h1(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Meta: styled(PersonCardMeta)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  Badge: styled(Badge)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Image: styled(PersonImage)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var PersonBanner = function (props) {
  var _a, _b;
  var className = props.className,
    children = props.children,
    colorStripSize = props.colorStripSize,
    entity = props.entity;
  var colorStripColor = (_a = entity === null || entity === void 0 ? void 0 : entity.color) === null || _a === void 0 ? void 0 : _a.value;
  var showColorStrip = props.showColorStrip === undefined ? !!((_b = entity.color) === null || _b === void 0 ? void 0 : _b.value) : props.showColorStrip;
  return React.createElement(My.Container, {
    colorStripColor: colorStripColor,
    colorStripSize: showColorStrip ? colorStripSize : 0,
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.Info, null, React.createElement(My.Name, null, entity === null || entity === void 0 ? void 0 : entity.name), React.createElement(My.Meta, {
    useProfile: false,
    entity: entity
  }), entity.badge && React.createElement(My.Badge, null, entity === null || entity === void 0 ? void 0 : entity.badge))), React.createElement(My.Image, {
    size: 128,
    entity: entity
  }), children);
};
PersonBanner.defaultProps = PersonBannerDefaultProps;
PersonBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;